import React, { useState, useRef, useEffect } from 'react';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './AddRowButton.css';

interface AddRowButtonProps {
  onAddRows: (count: number) => void;
}

const AddRowButton: React.FC<AddRowButtonProps> = ({ onAddRows }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const rowOptions = [
    { label: 'Add 10 rows', count: 10 },
    { label: 'Add 25 rows', count: 25 },
    { label: 'Add 50 rows', count: 50 },
    { label: 'Add 100 rows', count: 100 }
  ];

  const handleAddSingleRow = () => {
    onAddRows(1);
  };

  const handleDropdownClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleOptionClick = (count: number) => {
    onAddRows(count);
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div className="add-row-button-container" ref={buttonRef}>
      <button 
        className="add-row-main-button"
        onClick={handleAddSingleRow}
        type="button"
        title="Add 1 row"
      >
        <AddOutlinedIcon style={{ fontSize: '14px' }} />
        Add row
      </button>
      
      <button 
        className="add-row-dropdown-button"
        onClick={handleDropdownClick}
        type="button"
        title="Add multiple rows"
      >
        <KeyboardArrowUpIcon style={{ fontSize: '14px' }} />
      </button>
      
      {isMenuOpen && (
        <div className="add-row-menu">
          {rowOptions.map((option) => (
            <button
              key={option.count}
              className="add-row-menu-item"
              onClick={() => handleOptionClick(option.count)}
              type="button"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddRowButton; 